import React from "react";

export default function FilterIcon(props?: any) {

  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
  .filter(key => svgStyles[key] !== null && svgStyles[key] !== undefined)
  .reduce((acc: any, key) => {
    acc[key] = svgStyles[key];
    return acc;
  }, {});


  return (
    <svg       
      viewBox="0 0 32 32"
      fill="none" 
      style={{...filteredStyles}}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m29.81 2.19a7.42 7.42 0 0 0 -5.28-2.19h-17.06a7.47 7.47 0 0 0 -7.47 7.47v17.06a7.47 7.47 0 0 0 7.47 7.47h17.06a7.47 7.47 0 0 0 7.47-7.47v-17.06a7.42 7.42 0 0 0 -2.19-5.28zm.05 22.35a5.33 5.33 0 0 1 -5.33 5.33h-17.06a5.33 5.33 0 0 1 -5.33-5.33v-17.07a5.33 5.33 0 0 1 5.33-5.34h17.06a5.33 5.33 0 0 1 5.33 5.33z"/><path d="m23.47 10.67h-9.6v-1.07a1.07 1.07 0 0 0 -2.13 0v1.07h-3.21a1.07 1.07 0 1 0 0 2.13h3.2v1.07a1.07 1.07 0 0 0 2.13 0v-1.07h9.6a1.07 1.07 0 0 0 0-2.13z"/><path d="m23.47 19.2h-3.2v-1.07a1.07 1.07 0 0 0 -2.13 0v1.07h-9.61a1.07 1.07 0 1 0 0 2.13h9.6v1.07a1.07 1.07 0 1 0 2.13 0v-1.07h3.2a1.07 1.07 0 0 0 0-2.13z"/>
    </svg>
  )
}